import request from '../utils/fetch'

export function getHouseStockList (data) {
  return request({
    url: '/house/stock/getHouseStockList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseStockCheckList (data) {
  return request({
    url: '/house/stock/getHouseStockCheckList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseStockCheckInfo (data) {
  return request({
    url: '/house/stock/getHouseStockCheckInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getAllList (data) {
  return request({
    url: '/ouse/stock/getAllList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function editRemark (data) {
  return request({
    url: '/house/store/editRemark',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function addHouseStockCheck (data) {
  return request({
    url: '/house/store/addHouseStockCheck',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}






